import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  standalone: false,
  selector: 'app-loader',
  template: `
    <div *ngIf="loaderService.loading$ | async" class="fixed inset-0 flex  bg-neutral-gray20 items-center justify-center bg-opacity-60 z-50">
      <div class="h-16 w-16 animate-spin rounded-full border-4 border-neutral-gray30 border-t-primary-90"></div>
    </div>
  `
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
